import { Autocomplete, TextField } from "@mui/material";
import { FieldError } from "react-hook-form";

export const unitOptions = [
	"Inches",
	"Feet",
	"Yards",
	"Miles",
	"Pounds",
	"Ounces",
	"Gallons",
	"Quarts",
	"Pints",
	"Fluid Onces",
	"Turns",
	"-",
];

type Props = {
	label?: string;
	value: string | null;
	onChange?: Function;
	fieldError?: FieldError | undefined;
	disabled?: boolean;
};

export const UnitSelector = ({
	label = "Unit",
	value,
	onChange = () => {},
	fieldError,
	disabled = false,
}: Props) => {
	const selectedType = unitOptions.find((u) => u === value) || null;

	return (
		<Autocomplete
			id="clear-on-escape"
			clearOnEscape
			options={unitOptions}
			getOptionLabel={(option) => option}
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					variant="outlined"
					fullWidth
					error={!!fieldError}
					helperText={fieldError?.message}
					size="small"
				/>
			)}
			value={selectedType}
			onChange={(event, newValue) => {
				onChange(newValue ?? null);
			}}
			disabled={disabled}
		/>
	);
};
